import { graphql } from "babel-plugin-relay/macro";
import React from "react";
import { createFragmentContainer } from "react-relay";
import { GridSingleSelectElement_element$data } from "../../__generated__/GridSingleSelectElement_element.graphql";
import { GridSingleSelectElement_screener$data } from "../../__generated__/GridSingleSelectElement_screener.graphql";
import { CommonElementProps } from "./Element";
import { ElementBase } from "./index";

type Props = {
  element: GridSingleSelectElement_element$data;
  screener: GridSingleSelectElement_screener$data;
} & CommonElementProps;
const GridSingleSelectElement: React.FC<Props> = props => <ElementBase {...props} />;

export default createFragmentContainer(GridSingleSelectElement, {
  element: graphql`
    fragment GridSingleSelectElement_element on ElementNode {
      ...ElementBase_element
    }
  `,
  screener: graphql`
    fragment GridSingleSelectElement_screener on ScreenerNode {
      ...ElementBase_screener
    }
  `,
});
